if (!customElements.get('text-truncate')) {
  customElements.define('text-truncate', class extends HTMLElement {
    constructor() {
      super();
      this.target = this.parentElement;
      if (!this.target?.classList.contains('text-block--truncate')) {
        console.warn('text-truncate: No target element found.');
        return;
      }
      this.attachShadow({ mode: 'open' });
      this.shadowRoot.innerHTML = `
        <style>
          button {
            background: none;
            border: none;
            color: currentColor;
            cursor: pointer;
            font-family: inherit;
            font-size: inherit;
            padding: 0;
            text-decoration: underline;
          }
        </style>
        <button type="button">Read More</button>
      `;
      this.button = this.shadowRoot.querySelector('button');
      this.button.addEventListener('click', () => {
        this.button.textContent = this.target.classList.contains('text-block--expanded') ? 'Read More' : 'Read Less';
        this.target.classList.toggle('text-block--expanded');
      });
    }
  });
}